import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useProductStore = defineStore('product', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/products', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/products', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/products/' + params.hash, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/products/' + params.hash);
    };

    // Bulk delete products by array of ids
    const bulkDestroy = (ids) => {
        return axios.post('/api/v1/products/bulk-delete', { ids });
    };

    return {
        all,
        reset,
        search,
        store,
        update,
        destroy,
        bulkDestroy,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useProductStore, import.meta.hot));
}
